import { FileToUpload } from './filetoupload';
import { OnboardVrifications } from './OnboardVrifications';
import { OnboardEmpDoc } from './OnboardEmpDoc';
import { OnboardHREmpDoc } from './OnboardHREmpDoc';
import { HREmpMultipleDoc } from './hrEmpMultipleDocs';
export class OnboardEducationDetails {
  Id: number;
  EmpId: number;
  Qualification: string;
  University: string;
  MarksPercent: number;
  YearOfPassing: number;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  onboardVrifications: OnboardVrifications = new OnboardVrifications();
  OnboardHREmpDocs: OnboardHREmpDoc[];
  AdditionalDocuments: OnboardHREmpDoc[];
}

export class OnboardEmpAdditionalQualifications {
  Name: string;
  additionalDocs: OnboardHREmpDoc[] = [];
}
